import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Flex } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { BenefitItem } from './BenefitItem.js';
export const Benefits = () => {
    const { t } = useTranslation();
    const benefits = [
        t('loginregistration.fullscreenModalContent.benefits.benefit1'),
        t('loginregistration.fullscreenModalContent.benefits.benefit2'),
        t('loginregistration.fullscreenModalContent.benefits.benefit3'),
    ];
    return (_jsx(Flex, { flxDirection: 'column', gap: ['spaceXs', 'spaceS', 'spaceS2'], sx: { height: '100%' }, children: benefits.map((benefit) => {
            return _jsx(BenefitItem, { text: benefit }, benefit);
        }) }));
};
//# sourceMappingURL=Benefits.js.map